var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vx-upload"
  }, [_vm._l(_vm.uploadList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "vx-pic-content",
      on: {
        "mouseenter": _vm.onEnter,
        "mouseleave": _vm.onLeave
      }
    }, [item.status === 'finished' ? [_c('img', {
      staticClass: "vx-pic",
      attrs: {
        "src": item[_vm.urlAlias]
      }
    }), _c('span', {
      staticStyle: {
        "display": "inline-block",
        "height": "100%",
        "vertical-align": "middle"
      }
    }), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isInside,
        expression: "isInside"
      }],
      staticClass: "upload-common-button upload-close-button",
      attrs: {
        "title": $t("eslg2", "删除")
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onClickDelete(item);
        }
      }
    }, [_c('Icon', {
      attrs: {
        "size": 19,
        "type": "md-close"
      }
    })], 1), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isInside,
        expression: "isInside"
      }],
      staticClass: "upload-common-button upload-expand-button",
      attrs: {
        "title": $t("hpk92", "放大")
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onClickExpand(item);
        }
      }
    }, [_c('Icon', {
      attrs: {
        "size": 19,
        "type": "md-qr-scanner"
      }
    })], 1)] : [item.showProgress ? _c('Progress', {
      staticClass: "upload-progress",
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2);
  }), _c('Upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.uploadVisible,
      expression: "uploadVisible"
    }],
    ref: "upload",
    attrs: {
      "type": "drag",
      "name": _vm.name,
      "headers": _vm.headers,
      "show-upload-list": false,
      "format": _vm.format,
      "on-format-error": _vm.onFormatError,
      "max-size": 5120,
      "on-exceeded-size": _vm.onWxceededSize,
      "action": _vm.action,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.onSuccess,
      "on-progress": _vm.onProgress,
      "on-error": _vm.onError
    }
  }, [_c('div', {
    staticClass: "upload-content"
  }, [_c('div', {
    staticClass: "upload-tip-content"
  }, [_c('Icon', {
    staticClass: "upload-label",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _c('p', [_vm._v($t("ueu1kmb", "点击上传或拖动图片至此"))]), _vm._t("tip")], 2)])])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };